export enum MeetingsErrorCode {
    userHasSlotAtThisSchedule = "meeting.userHasSlotAtThisSchedule",

    /**
     * В указанное время у пользователя {userId} существует запись {slotId} на встречу.
     */
    userHasSlotAtThisPeriod = "meeting.userHasSlotAtThisPeriod"
}